import { useEffect } from 'react';
import { useApiContext } from 'react-easyrocket';
import { useNavigate, useSearchParams } from 'react-router';
import { EMAIL_SEARCH_PARAM } from 'src/constants';
import { useAuthFlow } from 'src/modules/authFlow/hooks/useAuthFlow';
import { useRoute } from 'src/router/hooks/useRoute';

type AuthMode = 'login' | 'signup';

interface AuthRouteProps {
  mode: AuthMode;
}

export const AuthRoute = ({ mode }: AuthRouteProps) => {
  const [searchParams] = useSearchParams();
  const { startLogin, startRegistration } = useAuthFlow();
  const { ROUTE } = useRoute();
  const navigate = useNavigate();
  const email = searchParams.get(EMAIL_SEARCH_PARAM);
  const { isAuthenticated } = useApiContext();
  const isApiContextReady = typeof isAuthenticated === 'boolean';

  useEffect(() => {
    navigate(ROUTE.MAIN.get());
    if (isApiContextReady) {
      if (isAuthenticated) {
        return;
      }

      const authAction = mode === 'login' ? startLogin : startRegistration;

      authAction({
        props: { email },
        replace: true
      });
    }
  }, [email, mode, isAuthenticated]);

  return null;
};
